import { render, staticRenderFns } from "./EmailAddress.vue?vue&type=template&id=0dd1bb4f&"
import script from "./EmailAddress.vue?vue&type=script&lang=js&"
export * from "./EmailAddress.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports